// Open Haunt on a title page (docs/programming/crosspromo.md, "games"): a Halloween-row game shows a small
// "Part of Open Haunt" chip linking to the hub while the zone is in season, and its More like this leads with other
// Halloween-row games. Both go away by themselves when the season ends (11 Nov) or the row leaves the catalogue.

import type { Catalogue, Game } from "../../catalogue.ts";
import { h, link } from "../../dom.ts";
import { zoneById, zoneHref } from "../registry.ts";
import { zoneInSeason } from "../spec.ts";

export const HAUNT_ZONE = "open-haunt";

/**
 * The Halloween row's game ids while Open Haunt is in season (accounts' row and the zone's dates both say so), else
 * an empty set.
 */
export function hauntGames(cat: Pick<Catalogue, "rows">, now: number): Set<string> {
  const z = zoneById(HAUNT_ZONE);
  if (!z) return new Set();
  const rows = cat.rows ?? [];
  if (!zoneInSeason(z, now, new Set(rows.map((r) => r.id)))) return new Set();
  const rowId = z.season?.gate?.row ?? "halloween";
  return new Set(rows.find((r) => r.id === rowId)?.games ?? []);
}

/** The chip, or null when the game isn't in the running Halloween row. */
export function hauntChip(g: Pick<Game, "id">, haunt: ReadonlySet<string>): HTMLElement | null {
  const z = zoneById(HAUNT_ZONE);
  if (!z || !haunt.has(g.id)) return null;
  return link(zoneHref(z), { class: "gt-chip gt-chip-haunt", "aria-label": `Part of ${z.title}: see every haunt` }, h("span", { class: "gt-chip-dot", "aria-hidden": "true" }), `Part of ${z.title}`);
}
